module.exports = __webpack_public_path__ + "static/Footer Replacement-fa9e320e2ff2c24234c16928aa46e77a.png";